import createActionTypes from './createActionTypes';

export const namespace = 'RETAILER_CART';

export const types = createActionTypes(namespace, ['ADD_PRODUCT']);

export const addProductToCart = (tagId) => ({
  type: types.ADD_PRODUCT,
  payload: { tagId },
});
